// removed by extract-text-webpack-plugin
module.exports = {"navContainer":"i0V2zx8uoVhYhVMiy6-tw","headerLink":"_3_IaGrW3QL6Rf1kcOHtojw","navLink":"vaFnbjtK6ETiU7uUrYSFR","navWide":"_11LeC66iPNaXKJw0S6BjHw"};


//////////////////
// WEBPACK FOOTER
// ./src/componentStyles/NavBar.css
// module id = 389
// module chunks = 0